const isApp = (...appNames: string[]): boolean => {
  const app = process.env.REACT_APP_NAME?.toLowerCase()
  return app ? appNames.some(name => name.toLowerCase() === app) : false
}

// Ejemplo de funciones específicas, si las necesitas
const isTeaConnection = (): boolean => isApp('tea')
const isGEConnection = (): boolean => isApp('ge')
const isLepainConnection = (): boolean => isApp('le-pain-quotidien')

// Configuración de integraciones con partners
const integrations = {
  tucan: {
    enabled: process.env.REACT_APP_TUCAN_ENABLED === 'true',
  },
  toteat: {
    enabled: process.env.REACT_APP_TOTEAT_ENABLED === 'true',
  },
}

// Configuración de módulos
const modules = {
  promos: {
    enabled: process.env.REACT_APP_PROMOS_ENABLED === 'true',
  },
  campaignPopUps: {
    enabled: process.env.REACT_APP_CAMPAIGN_POP_UPS_ENABLED === 'true',
  },
  campaignEmail: {
    enabled: process.env.REACT_APP_CAMPAIGN_EMAIL_ENABLED === 'true',
  },
}

const reviews = {
  enabled: process.env.REACT_APP_REVIEWS_ENABLED === 'true',
}

const ecard = {
  enabled: process.env.REACT_APP_ECARD_ENABLED === 'true',
}

// Verifica si hay alguna integración habilitada
const hasAnyIntegrationEnabled = (): boolean => {
  return integrations.tucan.enabled || integrations.toteat.enabled
}

export const ConfigUtils = {
  isApp,
  isTeaConnection,
  isGEConnection,
  isLepainConnection,
  integrations,
  modules,
  reviews,
  ecard,
  hasAnyIntegrationEnabled,
}
